import styled from 'styled-components';

export const Paragraph = styled.div`
    text-align: center;
    color: rgb(100,100,100);
`;
